var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price"},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.currency))]),_c('span',{staticClass:"num"},[_c('span',{staticClass:"en"},[_vm._v(_vm._s(_vm.ovalue))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }